import { AskTripUpdateOutput } from '@allocab/allocab-commons-shared-types';
import { PassengerAskTripUpdateInput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { passengerApi } from '../services/network/Api';

type Input = PassengerAskTripUpdateInput & { key: string; jwtToken: string };

const anonymousAskUpdate = ({ key, jwtToken, ...input }: Input) =>
  passengerApi.post<PassengerAskTripUpdateInput, AskTripUpdateOutput>(`anonymous/v1/${key}/ask-update`, input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

export const useAnonymousAskUpdate = () => {
  return useMutation<AskTripUpdateOutput, unknown, Input>({
    mutationFn: anonymousAskUpdate,
  });
};
